import { render } from "./AiChatPanel.vue?vue&type=template&id=3157838a&scoped=true"
import script from "./AiChatPanel.vue?vue&type=script&lang=js"
export * from "./AiChatPanel.vue?vue&type=script&lang=js"

import "./AiChatPanel.vue?vue&type=style&index=0&id=3157838a&lang=css"
import "./AiChatPanel.vue?vue&type=style&index=1&id=3157838a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3157838a"]])

export default __exports__